import React, { useEffect, useState } from 'react';
import AboutProject from './AboutProject';
import Activities from './Activities';
import Tenders from './Tenders';
import { useLocation } from 'react-router-dom';

const SokProjectPage = () => {
  const [currentComponent, setCurrentComponent] = useState(1);

  const location = useLocation();
  useEffect(() => {
    if (location.search) {
      setCurrentComponent(3);
    }
  }, [location.search]);

  return (
    <div className="d-flex">
      <div
        style={{ height: 'fit-content', width: '30%', textAlign: 'left' }}
        class="project-sidebar goals-box links-container "
      >
        <div
          onClick={() => setCurrentComponent(1)}
          style={{
            cursor: 'pointer',
            borderBottom: `${currentComponent === 1 ? '2px solid #6fc05d' : ''}`
          }}
          className="link-box d-flex"
        >
          <h3 className="ml-3">O Projektu</h3>
        </div>
        <div
          onClick={() => setCurrentComponent(1)}
          style={{ cursor: 'pointer' }}
          className="link-box d-flex"
        >
          <h3 className="ml-3">
            <a href="/files/prijava-za-ucesce-u-projektu.doc" download>
              PRIJAVA ZA UČEŠĆE U PROJEKTU
            </a>
          </h3>
        </div>
        <div
          onClick={() => setCurrentComponent(3)}
          style={{
            cursor: 'pointer',
            borderBottom: `${currentComponent === 3 ? '2px solid #6fc05d' : ''}`
          }}
          className="link-box d-flex"
        >
          <h3 className="ml-3">Aktivnosti</h3>
        </div>
        <div
          onClick={() => setCurrentComponent(4)}
          style={{
            cursor: 'pointer',
            borderBottom: `${currentComponent === 4 ? '2px solid #6fc05d' : ''}`
          }}
          className="link-box d-flex"
        >
          <h3 className="ml-3">Tenderi i Javni Pozivi</h3>
        </div>
      </div>
      {currentComponent === 1 && <AboutProject />}
      {currentComponent === 3 && <Activities />}
      {currentComponent === 4 && <Tenders />}
    </div>
  );
};

export default SokProjectPage;
